import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

jQuery(document).ready(function () {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  const section = document.querySelector('.clients-list');
  if (!section) return;

  const header = document.querySelector('.header');
  const titles = section.querySelector('.clients-list__titles');
  const items = section.querySelectorAll('.clients-list__item');
  if (!items.length || !header) return;

  const overlap = 14;
  const totalItems = items.length;
  const offset = 0.1;
  let mainScrollTrigger;

  function setItemsTop() {
    const headerHeight = header.offsetHeight;
    const baseTop = headerHeight + 30;

    items.forEach((item, index) => {
      item.style.top = `${baseTop + index * overlap}px`;
    });
  }

  function createScrollTriggers() {
    if (mainScrollTrigger) mainScrollTrigger.kill();
    ScrollTrigger.getAll().forEach((t) => t.kill());

    items.forEach((item, i) => {
      if (i === 0) item.classList.add('is-active');
      else item.classList.remove('is-active');
    });

    mainScrollTrigger = ScrollTrigger.create({
      id: 'ourClientsPin',
      trigger: section,
      start: 'top top',
      end: () => `+=${section.scrollHeight + totalItems * overlap}`,
      scrub: true,
      onUpdate: (self) => {
        const progress = self.progress;
        const virtualIndex = Math.max(
          0,
          ((progress - offset) / (1 - offset)) * (totalItems - 1)
        );

        let activeIndex = 0;
        items.forEach((item, i) => {
          const rect = item.getBoundingClientRect();
          const triggerY = window.innerHeight * 0.3;
          if (rect.top <= triggerY) activeIndex = i;
        });

        items.forEach((item, i) => {
          if (i === activeIndex) item.classList.add('is-active');
          else item.classList.remove('is-active');

          const distance = virtualIndex - i;
          let scale = 1;
          let opacity = 1;

          if (distance > 0 && distance <= 1) {
            scale = gsap.utils.interpolate(1, 0.9, distance);
            opacity = gsap.utils.interpolate(1, 0.8, distance);
          } else if (distance > 1 && distance <= 2) {
            scale = gsap.utils.interpolate(0.9, 0.85, distance - 1);
            opacity = gsap.utils.interpolate(0.8, 0.6, distance - 1);
          } else if (distance > 2 && distance <= 3) {
            scale = gsap.utils.interpolate(0.85, 0.8, distance - 2);
            opacity = gsap.utils.interpolate(0.6, 0, distance - 2);
          } else if (distance > 3) {
            scale = 0.8;
            opacity = 0;
          }

          gsap.to(item, {
            scale,
            opacity,
            duration: 0.3,
            ease: 'power2.out',
            overwrite: true,
          });
        });

        titleItems.forEach((titleItem, i) => {
          if (i === activeIndex) titleItem.classList.add('is-active');
          else titleItem.classList.remove('is-active');
        });
      },
    });

    const itemsWrapper = section.querySelector('.clients-list__items');
    if (!itemsWrapper) return;

    gsap.to(itemsWrapper, {
      y: () => -(totalItems * overlap * 0.6),
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: () => `+=${section.scrollHeight + totalItems * overlap}`,
        scrub: true,
      },
    });

    gsap.to(items, {
      y: (i) => i * overlap,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: () => `+=${section.scrollHeight + totalItems * overlap}`,
        scrub: true,
      },
    });
  }

  function scrollToItem(index) {
    if (!items.length) return;
    const targetItem = items[index];
    if (!targetItem) return;

    if (window.innerWidth <= 768) {
      const baseOffset = header.offsetHeight + 20;
      const step = 7;

      const dynamicOffset = baseOffset + index * step;

      const targetPosition =
        targetItem.getBoundingClientRect().top + window.scrollY - dynamicOffset;

      gsap.to(window, {
        duration: 1,
        scrollTo: targetPosition,
        ease: 'power2.inOut',
      });
      return;
    }
    if (!mainScrollTrigger) return;

    const gap = 28;
    const overlapPx = overlap;
    const itemsWrapper = section.querySelector('.clients-list__items');
    if (!itemsWrapper) return;

    const viewportWidth = window.innerWidth;
    const adaptiveOffset = Math.max(0, Math.min(40, viewportWidth * 0.05));

    let cumulativeHeight = 0;
    for (let i = 0; i < index; i++) {
      cumulativeHeight += items[i].offsetHeight - overlapPx + gap;
    }

    const sectionTop = section.offsetTop;
    const headerHeight = header.offsetHeight + (titles?.offsetHeight || 0);

    const wrapperHeight = itemsWrapper.offsetHeight;
    const itemsCount = items.length;

    let dynamicOffset =
      wrapperHeight / itemsCount + gap + overlapPx * (itemsCount - 1);

    if (window.innerWidth > 768 && window.innerWidth <= 1023) {
      dynamicOffset -= 180;
    }

    const targetScrollPosition =
      sectionTop +
      cumulativeHeight -
      headerHeight +
      dynamicOffset -
      gap -
      adaptiveOffset +
      parseFloat(getComputedStyle(document.documentElement).fontSize) * 6.25;

    gsap.to(window, {
      duration: 1.2,
      scrollTo: targetScrollPosition,
      ease: 'power2.inOut',
    });
  }

  const titleItems = section.querySelectorAll('.clients-list__titles-item');
  titleItems.forEach((titleItem, index) => {
    titleItem.addEventListener('click', () => scrollToItem(index));
  });

  function init() {
    setItemsTop();
    createScrollTriggers();
  }

  init();
  window.addEventListener('resize', () => {
    init();
    ScrollTrigger.refresh();
  });
});
